import React from 'react'
import { useQuery } from '@apollo/client'
import ErrorLoading from './ErrorLoading'
import Dashboard from './Dashboard'
import Loading from './Loading'
import { useRefetch } from '../../../hooks/useRefetch'
import { MEMBERSHIP_JOURNEY_QUERY } from '../../queries/member'
import { COACH_TOOLS_API } from '../../../apolloClient'

export const MembershipJourneyDashboardWrapper = ({ authReady, onEditProfile, history }) => {
  const { isFetching, reload } = useRefetch()

  const { data, loading, error, refetch } = useQuery(MEMBERSHIP_JOURNEY_QUERY, {
    context: {
      api: COACH_TOOLS_API
    },
    skip: !authReady,
    fetchPolicy: 'cache-and-network'
  })

  if (!authReady || loading || isFetching) {
    return <Loading />
  }
  
  const pgmProgress = data?.me?.pgmProgressStatus
  
  if (error || !pgmProgress || !data?.me) {
    return <ErrorLoading refetch={refetch} reload={reload} />
  }

  return (
    <Dashboard
      me={data.me}
      pgmProgress={pgmProgress}
      onEditProfile={onEditProfile}
      history={history}
      authReady={authReady}
    />
  )
}

export default MembershipJourneyDashboardWrapper
